import { Component, Input } from "@angular/core";
import { SiselsePerson } from "src/app/interfaces/siselse";
import { FunctionsService } from "src/app/services/functions/functions.service";
import { SiselseService } from "src/app/services/siselse/siselse.service";

import { Location } from "@angular/common";
@Component({
  selector: "siselse-list-persons",
  templateUrl: "./person-list.component.html",
})
export class SiselseListPersonsComponent {
  maxPersons = 16; // Número máximo de personas permitidas
  constructor(
    private funcService: FunctionsService,
    private siselse: SiselseService,
    private location: Location
  ) {}
  @Input() persons: SiselsePerson[] = [];
  @Input() type: "habitant" | "frequent" | "condomino";
  @Input() siselsePlaceId: string;
  @Input() totalPersons: number = 0;

  addPerson() {
    console.log("totalPersons", this.totalPersons);
    if (this.totalPersons >= this.maxPersons) {
      this.funcService.showToast(
        "No se pueden agregar más personas. El límite es de " +
          this.maxPersons +
          " personas."
      );
      return;
    }
    const lastPerson = this.persons[this.persons.length - 1];

    // Verifica si la última persona agregada está vacía
    if (
      lastPerson &&
      !lastPerson.nombrecondomino &&
      !lastPerson.apellidopcondomino &&
      !lastPerson.apellidomcondomino
    ) {
      console.log("La última persona está vacía. No se agregará otra.");
      this.funcService.showToast(
        "La última persona está vacía. No se agregará otra."
      );
      return;
    }
    this.persons.push({
      nombrecondomino: "",
      apellidopcondomino: "",
      apellidomcondomino: "",
      tipocondomino:
        this.type === "condomino" ? "1" : this.type === "habitant" ? "2" : "3",
      casa_idcasa: this.siselsePlaceId,
    });
  }

  deletePerson(index: number) {
    this.persons.splice(index, 1);
  }

  saveDatos() {
    const persons = this.persons.filter(
      (persons) =>
        persons.nombrecondomino ||
        persons.apellidopcondomino ||
        persons.apellidomcondomino
    );
    // Aquí puedes utilizar el arrayDeDatos como desees, por ejemplo, enviarlo a un servicio para almacenarlo.
    this.funcService
      .showConfirm(
        "Guardar datos",
        "Los datos a almacenar seran guardados y remplazados",
        "Cancelar",
        "Guardar"
      )
      .then((save) => {
        if (save) {
          console.log(persons);
          this.siselse
            .setPersons(this.siselsePlaceId, this.type, persons)
            .then((res) => {
              console.log(res);
              this.location.back();
            });
        }
      });
  }
}
